import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../filters';
import * as files from '../../fileUtils';
import users from '../../users';

export default {
  name: 'Enquiries',
  components: {
    DataGridComp: require('../../customcontrols/datagrid.vue').default,
    filterDataComp: require('../../customcontrols/filterIcon.vue').default
  },
  mixins: [users],
  data: function () {
    return {
      canUseEnquiries2: false,
      lookupsLoaded: false,
      filterObj: [],
      options: { pageSize: 10, total: 0, page: 1 },
      totalRow: 0,
      filterBy: [
        { value: 0, title: 'AllAccounts', show: true },
        { value: 1, title: 'Tenant', show: true },
        { value: 2, title: 'Active', show: false },
        { value: 3, title: 'Owner', show: true },
        { value: 4, title: 'VolDisconnected', show: false }
      ],
      filterBySelected: [0],
      billingGroup: [],
      billingGroupSelected: '',
      customerName: '',
      idNo: '',
      Account: '',
      phoneNumber: '',
      oldAccount: '',
      bankAccount: '',
      customerType: [],
      customerTypeSelected: '',
      watchList: [],
      watchListSelected: 0,
      town: [],
      townSelected: 0,
      township: [],
      townshipSelected: 0,
      consumptionType: [],
      consumptionTypeSelected: '',
      connectionStatus: [],
      connectionStatusSelected: '',
      propertyRef: '',
      meterRef: '',
      propertyAddress: '',
      buildingName: '',
      buildingId: '',
      lang: '',
      FilterResult: [],
      ResultColumns: [],
      noDataFound: false
    }
  },
  created() {
    //this.fillFiltersObj();
    this.checkCanUseEnquiries2();
    this.getLookups();
    this.fillResultGridColumns();
  },
  mounted() {
    Vue.prototype.$scrollToTop = () => window.scrollTo(0, 0);
  },
  methods: {
    checkCanUseEnquiries2() {
      axios.get('/Enquiries2/CanUse')
        .then(response => {
          this.canUseEnquiries2 = response.data;
          this.fillFiltersObj();
        });
    },
    getLookups() {
      axios.post('/Enquiries/GetLookups', { Value: this.getLoginName() })
        .then(response => {

          if (response.data.data.status == 0) {
            //console.log('GetLookups', response.data);
            this.billingGroup = response.data.billingGroups.sort((a, b) => a.groupId - b.groupId);
            this.billingGroupSelected = this.billingGroup == null ? '' : this.billingGroup.length == 0 ? '' : this.billingGroup[0]['groupId'];

            this.customerType = response.data.customerTypes.sort((a, b) => a.id - b.id);
            this.customerTypeSelected = this.customerType == null ? '' : this.customerType.length == 0 ? '' : this.customerType[0]['id'];

            this.watchList = response.data.watchLists;
            this.watchListSelected = this.watchList == null ? 0 : this.watchList.length == 0 ? 0 : this.watchList[0]['listId'];

            this.town = response.data.towns;
            this.townSelected = this.town == null ? 0 : this.town.length == 0 ? 0 : this.town[0]['id'];

            this.township = response.data.townships.sort((a, b) => a.id - b.id);
            this.townshipSelected = this.township == null ? 0 : this.township.length == 0 ? 0 : this.township[0]['id'];

            this.consumptionType = response.data.consumptionTypes;
            this.consumptionTypeSelected = this.consumptionType == null ? '' : this.consumptionType.length == 0 ? '' : this.consumptionType[0]['id'];

            this.connectionStatus = response.data.connectionStatus;
            this.connectionStatusSelected = this.connectionStatus == null ? '' : this.connectionStatus.length == 0 ? '' : this.connectionStatus[0]['id'];

            this.lookupsLoaded = true;
          }
          else {
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => { return false; })
    },
    pageChange(pInfo) {
      if (pInfo.pageNumber == this.options.page && pInfo.pageSize == this.options.pageSize)
        return;

      this.options.page = pInfo.pageNumber;
      this.options.pageSize = pInfo.pageSize;
      this.filterCustomers();
    },
    filterCustomers() {
      var criteria = {};

      if (this.canUseEnquiries2) {
        criteria['custKeys'] = this.Account;
        criteria['checkAll'] = this.filterBySelected.filter(a => a == 0).length > 0 ? true : false;
        criteria['checkTenants'] = this.filterBySelected.filter(a => a == 1).length > 0 ? true : false;
        criteria['checkOwners'] = this.filterBySelected.filter(a => a == 3).length > 0 ? true : false;
      } else {
        criteria['custKeyText'] = this.Account;
        criteria['chkAllAccounts'] = this.filterBySelected.filter(a => a == 0).length > 0 ? true : false;
        criteria['chkTenant'] = this.filterBySelected.filter(a => a == 1).length > 0 ? true : false;
        criteria['chkOwner'] = this.filterBySelected.filter(a => a == 3).length > 0 ? true : false;


        criteria['volDisconnected'] = this.filterBySelected.filter(a => a == 3).length > 0 ? true : false;
        criteria['chkActiveAccounts'] = this.filterBySelected.filter(a => a == 2).length > 0 ? true : false;
        criteria['propertyAddressRef'] = this.propertyAddress;
      }

      criteria['billingGroupId'] = this.billingGroupSelected;
      criteria['name'] = this.customerName;
      criteria['oldKey'] = this.oldAccount;
      criteria['consumptionTypeId'] = this.consumptionTypeSelected;
      criteria['Options'] = this.options;

      for (var i = 0; i < this.filterObj.filter(a => a.added).length; i++) {
        criteria[this.filterObj.filter(a => a.added)[i].field] = this.filterObj.filter(a => a.added)[i].value;
      }

      //console.log('criteria', criteria);

      this.$store.state.notifier.asyncBlock(
        axios.post(this.canUseEnquiries2 ? '/Enquiries2/GetEnquiries' : '/Enquiries/SearchEnquiries', criteria),
        response => {
          if (response.status == 200) {
            if (response.data.items.length == 0) {
              this.FilterResult = [];
              this.noDataFound = true;
            }
            else {
              this.FilterResult = response.data.items;

              this.totalRow = response.data.itemsCount;
            }
          }
          else {
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        },
        err => {
          this.$oldAlertMsg(err.data, 4);
        }
      );
    },
    onSelectCustomer(info) {
      var route = '/customer/CustomerAllDetails/' + info.data.custkey + '/';
      if (info.data.propertyId)
        route = route + info.data.propertyId;

      this.$router.push(route);
    },
    clearControls() {
      this.filterBySelected = [0];
      this.billingGroupSelected = this.billingGroup == null ? '' : this.billingGroup.length == 0 ? '' : this.billingGroup[0]['groupId'];
      this.customerName = '';
      this.Account = '';
      this.oldAccount = '';
      this.consumptionTypeSelected = this.consumptionType == null ? '' : this.consumptionType.length == 0 ? '' : this.consumptionType[0]['id'];
      this.propertyAddress = '';
      this.FilterResult = [];

      this.$refs.filterComp.restFilters();
    },
    fillResultGridColumns() {
      this.ResultColumns = [];

      this.ResultColumns.push({ dataField: 'billingGroup', caption: this.$t('enquiries.BillingGroup') });
      this.ResultColumns.push({ dataField: 'custkey', caption: this.$t('enquiries.Account') });
      this.ResultColumns.push({ dataField: 'customerName', caption: this.$t('enquiries.CustomerName') });
      this.ResultColumns.push({ dataField: 'consumerType', caption: this.$t('enquiries.consumerType') });
      this.ResultColumns.push({ dataField: 'accountStatus', caption: this.$t('enquiries.accountStatus') });
      this.ResultColumns.push({ dataField: 'telNo', caption: this.$t('enquiries.telNo') });
      this.ResultColumns.push({ dataField: 'cellTelNo', caption: this.$t('enquiries.cellTelNo') });
      this.ResultColumns.push({ dataField: 'workTelNo', caption: this.$t('enquiries.workTelNo') });
      this.ResultColumns.push({ dataField: 'idNo', caption: this.$t('enquiries.idNo') });
      this.ResultColumns.push({ dataField: 'oldIdNo', caption: this.$t('enquiries.oldIdNo') });
      this.ResultColumns.push({ dataField: 'mailAddress', caption: this.$t('enquiries.mailAddress') });
      this.ResultColumns.push({ dataField: 'personalAddress', caption: this.$t('enquiries.personalAddress') });
      this.ResultColumns.push({ dataField: 'infoFlag1', caption: this.$t('enquiries.infoFlag1') });
      this.ResultColumns.push({ dataField: 'infoFlag2', caption: this.$t('enquiries.infoFlag2') });
      this.ResultColumns.push({ dataField: 'infoFlag3', caption: this.$t('enquiries.infoFlag3') });
      this.ResultColumns.push({ dataField: 'infoFlag4', caption: this.$t('enquiries.infoFlag4') });
      this.ResultColumns.push({ dataField: 'infoFlag5', caption: this.$t('enquiries.infoFlag5') });
      this.ResultColumns.push({ dataField: 'deparmentalCode', caption: this.$t('enquiries.deparmentalCode') });
      this.ResultColumns.push({ dataField: 'groupAccount', caption: this.$t('enquiries.groupAccount') });
      this.ResultColumns.push({ dataField: 'isCurrentTenant', caption: this.$t('enquiries.isCurrentTenant') });
      this.ResultColumns.push({ dataField: 'town', caption: this.$t('enquiries.town') });
      this.ResultColumns.push({ dataField: 'township', caption: this.$t('enquiries.township') });
      this.ResultColumns.push({ dataField: 'plotNo', caption: this.$t('enquiries.plotNo') });
      this.ResultColumns.push({ dataField: 'propRef', caption: this.$t('enquiries.PropRef') });
      this.ResultColumns.push({ dataField: 'ownerCustkey', caption: this.$t('enquiries.ownerCustkey') });
      this.ResultColumns.push({ dataField: 'ownerIdNo', caption: this.$t('enquiries.ownerIdNo') });
      this.ResultColumns.push({ dataField: 'propertyAddress', caption: this.$t('enquiries.propertyAddress') });
      this.ResultColumns.push({ dataField: 'propertyBuildingName', caption: this.$t('enquiries.propertyBuildingName') });
      this.ResultColumns.push({ dataField: 'waterService', caption: this.$t('enquiries.waterService') });
      this.ResultColumns.push({ dataField: 'sewerService', caption: this.$t('enquiries.sewerService') });
      this.ResultColumns.push({ dataField: 'propConsumptionType', caption: this.$t('enquiries.ConsumptionType') });
      this.ResultColumns.push({ dataField: 'waterTariff', caption: this.$t('enquiries.waterTariff') });
      this.ResultColumns.push({ dataField: 'sewerTariff', caption: this.$t('enquiries.sewerTariff') });
      this.ResultColumns.push({ dataField: 'propInfoFlag1Data', caption: this.$t('enquiries.propInfoFlag1Data') });
      this.ResultColumns.push({ dataField: 'propInfoFlag2Data', caption: this.$t('enquiries.propInfoFlag2Data') });
      this.ResultColumns.push({ dataField: 'propInfoFlag3Data', caption: this.$t('enquiries.propInfoFlag3Data') });
      this.ResultColumns.push({ dataField: 'propInfoFlag4Data', caption: this.$t('enquiries.propInfoFlag4Data') });
      this.ResultColumns.push({ dataField: 'propInfoFlag5Data', caption: this.$t('enquiries.propInfoFlag5Data') });
      this.ResultColumns.push({ dataField: 'connNo', caption: this.$t('enquiries.connNo') });
      this.ResultColumns.push({ dataField: 'connStatus', caption: this.$t('enquiries.connStatus') });
      this.ResultColumns.push({ dataField: 'connDate', caption: this.$t('enquiries.connDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.ResultColumns.push({ dataField: 'bookNo', caption: this.$t('enquiries.bookNo') });
      this.ResultColumns.push({ dataField: 'walkNo', caption: this.$t('enquiries.walkNo') });
      this.ResultColumns.push({ dataField: 'sequence', caption: this.$t('enquiries.sequence') });
      this.ResultColumns.push({ dataField: 'bulkConnectionId', caption: this.$t('enquiries.bulkConnectionId') });
      this.ResultColumns.push({ dataField: 'meterTypeRef', caption: this.$t('enquiries.meterTypeRef') });
      this.ResultColumns.push({ dataField: 'meterSerialNo', caption: this.$t('enquiries.meterSerialNo') });
      this.ResultColumns.push({ dataField: 'meterMake', caption: this.$t('enquiries.meterMake') });
      this.ResultColumns.push({ dataField: 'meterSize', caption: this.$t('enquiries.meterSize') });
      this.ResultColumns.push({ dataField: 'meterDials', caption: this.$t('enquiries.meterDials') });
    },
    fillFiltersObj() {
      this.filterObj.push(
        {
          defaultIndex: 0,
          index: 0,
          field: this.canUseEnquiries2 ? 'propertyRef' : 'propertyRefText',
          fieldDesc: this.$t('enquiries.PropRef'),
          type: 'text',
          addedDefault: true,
          defaultValue: '',
          value: '',
          added: true
        });

      this.filterObj.push(
        {
          defaultIndex: 1,
          index: 1,
          field: 'townId',
          fieldDesc: this.$t('enquiries.Town'),
          type: 'list',
          listSource: this.town.sort((a, b) => a.id - b.id),
          listValueField: 'id',
          listTextField: 'ref',
          addedDefault: false,
          defaultValue: this.town == null ? 0 : this.town.length == 0 ? 0 : this.town[0]['id'],
          value: this.town == null ? 0 : this.town.length == 0 ? 0 : this.town[0]['id'],
          added: false
        });

      this.filterObj.push(
        {
          defaultIndex: 2,
          index: 2,
          field: 'townshipId',
          fieldDesc: this.$t('enquiries.Township'),
          type: 'list',
          listSource: this.township.sort((a, b) => a.id - b.id),
          listValueField: 'id',
          listTextField: 'displayString',
          addedDefault: false,
          defaultValue: this.township == null ? 0 : this.township.length == 0 ? 0 : this.township[0]['id'],
          value: this.township == null ? 0 : this.township.length == 0 ? 0 : this.township[0]['id'],
          added: false
        });

      this.filterObj.push(
        {
          defaultIndex: 3,
          index: 3,
          field: this.canUseEnquiries2 ? 'connStatus' : 'connectionStatus',
          fieldDesc: this.$t('enquiries.ConnStatus'),
          type: 'list',
          listSource: this.connectionStatus.sort((a, b) => a.id - b.id),
          listValueField: 'id',
          listTextField: 'text',
          addedDefault: false,
          defaultValue: this.connectionStatus == null ? '' : this.connectionStatus.length == 0 ? '' : this.connectionStatus[0]['id'],
          value: this.connectionStatus == null ? '' : this.connectionStatus.length == 0 ? '' : this.connectionStatus[0]['id'],
          added: false
        });

      this.filterObj.push(
        {
          defaultIndex: 4,
          index: 4,
          field: this.canUseEnquiries2 ? 'meterRef' : 'meterRefText',
          fieldDesc: this.$t('enquiries.MeterRef'),
          type: 'text',
          addedDefault: false,
          defaultValue: '',
          value: '',
          added: false
        });

      this.filterObj.push(
        {
          defaultIndex: 5,
          index: 5,
          field: 'idNo',
          fieldDesc: this.$t('enquiries.CustomerId'),
          type: 'text',
          addedDefault: false,
          defaultValue: '',
          value: '',
          added: false
        });

      if (!this.canUseEnquiries2)
        this.filterObj.push(
          {
            defaultIndex: 6,
            index: 6,
            field: 'propertyBuildingNameText',
            fieldDesc: this.$t('enquiries.BuildingName'),
            type: 'text',
            addedDefault: false,
            defaultValue: '',
            value: '',
            added: false
          });

      if (!this.canUseEnquiries2)
        this.filterObj.push(
          {
            defaultIndex: 7,
            index: 7,
            field: 'propertyBuildingId',
            fieldDesc: this.$t('enquiries.BuildingId'),
            type: 'text',
            addedDefault: false,
            defaultValue: '',
            value: '',
            added: false
          });

      this.filterObj.push(
        {
          defaultIndex: 8,
          index: 8,
          field: 'consumerTypeId',
          fieldDesc: this.$t('enquiries.CustomerType'),
          type: 'list',
          listSource: this.customerType.sort((a, b) => a.id - b.id),
          listValueField: 'id',
          listTextField: 'text',
          addedDefault: false,
          defaultValue: this.customerType == null ? '' : this.customerType.length == 0 ? '' : this.customerType[0]['id'],
          value: this.customerType == null ? '' : this.customerType.length == 0 ? '' : this.customerType[0]['id'],
          added: false
        });

      this.filterObj.push(
        {
          defaultIndex: 9,
          index: 9,
          field: 'watchListId',
          fieldDesc: this.$t('enquiries.WatchList'),
          type: 'list',
          listSource: this.watchList.sort((a, b) => a.listId - b.listId),
          listValueField: 'listId',
          listTextField: 'name',
          addedDefault: false,
          defaultValue: this.watchList == null ? 0 : this.watchList.length == 0 ? 0 : this.watchList[0]['listId'],
          value: this.watchList == null ? 0 : this.watchList.length == 0 ? 0 : this.watchList[0]['listId'],
          added: false
        });

      this.filterObj.push(
        {
          defaultIndex: 10,
          index: 10,
          field: 'phone',
          fieldDesc: this.$t('enquiries.Phone'),
          type: 'text',
          addedDefault: false,
          defaultValue: '',
          value: '',
          added: false
        });

      this.filterObj.push(
        {
          defaultIndex: 11,
          index: 11,
          field: 'bankAccountNo',
          fieldDesc: this.$t('enquiries.BankAccount'),
          type: 'text',
          addedDefault: false,
          defaultValue: '',
          value: '',
          added: false
        });
    }
  },
}
